import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/StrategicConsulting/2148510529.jpg";
import { FaBullseye, FaChartLine, FaEthereum, FaMap, FaNetworkWired, FaPlug, FaRegChartBar, FaRocket, FaSync } from "react-icons/fa";

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Strategic Roadmap
            </h1>
            <p className="text-lg text-gray-600">
            Develop a detailed blockchain strategy and implementation plan tailored to your enterprise requirements.
						 </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaEthereum className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Evaluate Blockchain Suitability</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Assess the use of blockchain for specific business needs.
            </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaRegChartBar className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Monitor and Optimize
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
              Track performance and refine the strategy continuously.
            </p>
            </div>

          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}